import { lazy } from "@bridgesplit/ui";

import PortfolioLoanStats from "./stats/LenderLoanStats";
const PortfolioOverview = lazy(() => import("./PortfolioOverview"));

export { PortfolioOverview, PortfolioLoanStats };

export * from "./dialogs";
